import { BODY_SHAPE_OPTIONS } from '../../options/BodyShape/BODY_SHAPE_OPTIONS';
import { HAIR_COLOR_OPTIONS } from '../../options/HairColor/HAIR_COLOR_OPTIONS';
import { ScreenAge } from '../OwnAISecond/screens/Age';
import { ScreenAiSay } from '../OwnAISecond/screens/AiSay';
import { ScreenBodyShape } from '../OwnAISecond/screens/BodyShape';
import { ScreenChatInitiative } from '../OwnAISecond/screens/ChatInitiative';
import { ScreenCreatingAi } from '../OwnAISecond/screens/CreatingAi';
import { ScreenHairColor } from '../OwnAISecond/screens/HairColor';
import { ScreenIdealMatch } from '../OwnAISecond/screens/IdealMatch';
import { ScreenLoneliness } from '../OwnAISecond/screens/Loneliness';
import { ScreenLonelinessGraph } from '../OwnAISecond/screens/LonelinessGraph';
import { ScreenName } from '../OwnAISecond/screens/Name';
import { ScreenPersonality } from '../OwnAISecond/screens/Personality';
import { ScreenSecurity } from '../OwnAISecond/screens/Security';
import { ScreenSendPhotos } from '../OwnAISecond/screens/SendPhotos';
import { ScreenSettingUpProfile } from '../OwnAISecond/screens/SettingUpProfile';

import { ScreenMajorTurnOff } from './screens/MajorTurnOff';
import { ScreenSendVideo } from './screens/SendVideo';
import { LayoutDataType } from './types';

export const layoutSteps = {
  age: {
    component: ScreenAge,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/body_shape/${option.id}.png`,
    ),
  },
  hair_color: {
    component: ScreenHairColor,
    images: HAIR_COLOR_OPTIONS.map(
      (option) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/options/hair_color/${option.id}.png`,
    ),
  },
  creating_ai: {
    component: ScreenCreatingAi,
    images: [],
  },
  ai_say: {
    component: ScreenAiSay,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/ai-say-text.png',
    ],
  },
  ideal_match: {
    component: ScreenIdealMatch,
    images: [],
  },
  chat_initiative: {
    component: ScreenChatInitiative,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  major_turn_off: {
    component: ScreenMajorTurnOff,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/modal_send_photos.png',
    ],
  },
  send_photos: {
    component: ScreenSendPhotos,
    images: [],
  },
  send_videos: {
    component: ScreenSendVideo,
    images: [],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  loneliness: {
    component: ScreenLoneliness,
    images: [],
  },
  loneliness_graph: {
    component: ScreenLonelinessGraph,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-dark-violet.png',
    ],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  age: null,
  body_shape: null,
  hair_color: null,
  ideal_match: null,
  chat_initiative: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  major_turn_off: null,
  send_photos: null,
  send_videos: null,
  name: '',
  loneliness: null,
  characters: [],
};

// Category constants - not used, already hardcoded in SendPhotos screen
export const HARDCODED_CATEGORIES = [];
